import { Flex, XIcon } from '@blockanalitica/ui';
// @ts-ignore
import Logo from '@/assets/logos/BA-logo-full-white.svg?react';
// @ts-ignore
import SparkLogo from '@/assets/logos/sparklogotext.svg?react';
import { ExternalLink } from '@/components';
import { DateTime } from 'luxon';
import DiscordIcon from '../icons/DiscordIcon';
import ForumIcon from '../icons/ForumIcon';
import GithubIcon from '../icons/GithubIcon';

export default function Footer() {
  const currentYear = DateTime.now().year;
  return (
    <Flex
      as="footer"
      fontSize="-1"
      color="muted"
      padding="0 1"
      display="flex"
      flexDirection={['column', 'row']}
      justifyContent="space-between"
      alignItems="center"
      gap="s">
      <Flex gap="s" justifyContent="center" alignItems="center">
        <ExternalLink href="https://spark.fi">
          <SparkLogo height={32} />
        </ExternalLink>
        <span>|</span>
        <ExternalLink href="https://x.com/sparkdotfi" color="muted">
          <XIcon size="0" />
        </ExternalLink>
        <ExternalLink href="https://discord.gg/sparkdotfi" color="muted">
          <DiscordIcon size="1" />
        </ExternalLink>
        <ExternalLink href="https://github.com/sparkdotfi" color="muted">
          <GithubIcon size="1" />
        </ExternalLink>
        <ExternalLink
          href="https://forum.sky.money/c/spark-subdao/84"
          color="muted">
          <ForumIcon size="1" />
        </ExternalLink>
      </Flex>
      <Flex gap="xs" justifyContent="center" alignItems="center">
        <Flex gap="xs">
          <span>© {currentYear}</span>
          <span>|</span>
          <span>Made by</span>
        </Flex>

        <ExternalLink href="https://blockanalitica.com">
          <Logo height={32} />
        </ExternalLink>
        <span>|</span>

        <ExternalLink
          href="https://blockanalitica.com/terms-of-service/"
          color="muted">
          Terms of Service
        </ExternalLink>
      </Flex>
    </Flex>
  );
}
